import { updateShippingProgress } from "./shipping-progress.js";
import "./quick-add.js";
import "./cart-panel.js";
import "./search.js";
import "./navigation.js";

/* Leaving around for reference, the hero doesn't support video
const isReduced = window.matchMedia(`(prefers-reduced-motion: reduce)`) === true || window.matchMedia(`(prefers-reduced-motion: reduce)`).matches === true;
if (!!isReduced) {
    const heroVideo = document.querySelector('.wp-block-pulp-hero video');
    if (heroVideo) {
        heroVideo.pause();
    }
}
*/

/*
Cart Badge Update
*/
/**
 * Update the cart icon badge count and aria-label.
 * @param {number} count - Current cart item count
 */
function updateCartBadge(count) {
    const cartButton = document.querySelector('[data-cart-panel-open]');
    if (!cartButton) return;

    let badge = cartButton.querySelector('.utilities__cart-count');
    if (count > 0) {
        if (!badge) {
            // Create badge if doesn't exist
            badge = document.createElement('span');
            badge.className = 'utilities__cart-count';
            badge.setAttribute('aria-hidden', 'true');
            cartButton.insertBefore(badge, cartButton.firstChild);
        }
        badge.textContent = count;

        // Update ARIA label
        const itemText = count === 1 ? 'item' : 'items';
        cartButton.setAttribute('aria-label', `Open cart, ${count} ${itemText}`);
    } else {
        // Remove badge if count is 0
        badge?.remove();
        cartButton.setAttribute('aria-label', 'Open cart');
    }
}

// Listen for count updates from all cart components
document.addEventListener('cart:count:updated', (e) => {
    updateCartBadge(e.detail.count);
    if (typeof e.detail.total === 'number') {
        updateShippingProgress(e.detail.total);
    }
});

// Debug: check active focus element
// document.addEventListener('focusin', (e) => {
//     console.log('Focused element:', e.target);
// }); 
